import { ValidationError } from "class-validator";
import { ref, UnwrapRef } from "vue";

type Error<T> = {
  [P in keyof T]?: string | Error<T> | any[] | object;
};

export function useValidation<T extends object>() {
  const errors = ref<Error<T>>({} as Error<T>);

  const isValid = (): boolean => {
    return Object.keys(errors.value).length === 0;
  };

  const setError = (result: ValidationError[]): Error<T> => {
    const propBag: Error<T> = {} as Error<T>;

    const setNestedProperty = (obj: any, path: string[], value: any) => {
      let currentObj = obj;
      for (let i: number = 0; i < path.length - 1; i++) {
        if (!currentObj[path[i]]) {
          currentObj[path[i]] = {};
        }
        currentObj = currentObj[path[i]];
      }
      currentObj[path[path.length - 1]] = value;
    };

    const extractErrors = (errors: ValidationError[], parentPath: string[] = []) => {
      for (const error of errors) {
        const path: string[] = [...parentPath, error.property];

        if (error.constraints) {
          for (const key in error.constraints) {
            if (Object.prototype.hasOwnProperty.call(error.constraints, key)) {
              setNestedProperty(propBag, path, error.constraints[key]);
            }
          }
        }

        if (error.children && error.children.length > 0) {
          extractErrors(error.children, path);
        }
      }
    };

    extractErrors(result);
    return propBag;
  };

  const clearErrors = (): void => {
    errors.value = {} as UnwrapRef<Error<T>>;
  };

  return { errors, isValid, setError, clearErrors };
}
